<template>
    <v-snackbar z-index="2000" v-model="notification.flag" :color="notification.color" :timeout="notification.timeout">
        <div class="d-flex">
            <v-icon class="mr-2" :icon="notification.icon"></v-icon>
            <strong>{{ notification.title }}</strong>
        </div>
        <p>{{ notification.msg }}</p>
    </v-snackbar>
</template>

<script>
export default {
    name: 'Notification',
    props: {
        notification: {
            type: Object,
            required: true,
            default: () => ({
                flag: false,
                color: 'primary',
                timeout: 3000,
                icon: '',
                title: '',
                msg: ''
            })
        }
    }
};
</script>
